import React from 'react';

interface CardListProps<T> {
  items: T[];
  renderCard: (item: T, index: number) => React.ReactNode;
  isLoading?: boolean;
  loadingCount?: number;
  className?: string;
  gridClassName?: string;
  emptyMessage?: string;
}

export function CardList<T>({
  items,
  renderCard,
  isLoading,
  loadingCount = 4,
  className = '',
  gridClassName = 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
  emptyMessage = 'Không có dữ liệu hiển thị'
}: CardListProps<T>) {
  return (
    <div className={className}>
      <div className={`grid gap-4 ${gridClassName}`}>
        {isLoading ? (
          Array.from({ length: loadingCount }).map((_, idx) => (
            <div key={idx} className="h-32 animate-pulse rounded-md bg-white p-3 shadow-sm" />
          ))
        ) : (items?.length ?? 0) > 0 ? (
          items?.map((item, index) => renderCard(item, index))
        ) : (
          <div className="col-span-full py-12 text-center text-slate-400">
            <p className="text-sm">{emptyMessage}</p>
          </div>
        )}
      </div>
    </div>
  );
}
